import { Entity } from '../entity';
import { Attachment } from '../shared';

export enum DefectSeverity {
    Critical = 'Critical',
    High = 'High',
    Medium = 'Medium',
    Low = 'Low'
}

export enum DefectEntityType {
    Job = "Job",
    WorkOrder = "WorkOrder",
    Code = "Code"
}


export interface DefectCodeEntity extends Entity {
    location?: string;
}

export enum DefectQueryType {
    All = 'All',
    Resolve = 'Resolve',
    Unresolve = 'Unresolve'
}

export interface Defect extends Entity {
    defectNumber?: string;
    job?: Entity;
    workOrder?: Entity;
    code?: DefectCodeEntity;
    raisedBy: Entity;
    raisedAt?: Date;
    rectifiedBy?: Entity;
    rectifiedAt?: Date;
    severity: DefectSeverity;
    description?: string;
    resolve?: boolean;
    causedBy?: Entity;
    defectEvidence?: Attachment[];
    rectification?: Attachment[];
    timezone?: string;
    resolution?: string;

    createdAt?: Date;
    createdBy?: Entity;

    updatedAt?: Date;
    updatedBy?: Entity;
}

export interface DefectMetadata {
    job?: Entity;
    workOrder?: Entity;
    code?: DefectCodeEntity;
    type: DefectEntityType;
    timezone: string;
    dateFormat: string;
    readonly: boolean;
    currentUser?: Entity;
}
